import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Layout from "../../hocs/layout/Layout";
import NavBar from "../../components/navigation/Navbar";
import Footer from "../../components/navigation/Footer";
import NoticiasNovedades from "../../components/novedades/noticias";

function Noticias_novedades(){
    useEffect(() => {
        window.scrollTo(0,0)
    },[])

    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            setTimeout(() => {
                const element = document.querySelector(location.hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 100);
        }
    }, [location]);

    return(
        <Layout>
            <NavBar/>
            <div>
                <NoticiasNovedades/> 
            </div>
            <Footer/>
        </Layout>
    );
}export default Noticias_novedades;